<template>
<div class="box-labourParticulars">
    <div class="nav">
        <img src="../../assets/up.png" alt="" class="upClass" @click="getOnPage1">
        发票信息
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <!-- 公司发票信息 -->
    <div class="labourParticulars" v-if="fingerprintShow0">
        <h4 class="labourParticulars-title labourParticulars-title-active">公司发票信息</h4>
        <span class="spanClass">公司名称税号如下：微信扫描二维码可自动保存相关信息。</span>
        <img src="../../assets/imgContent1.jpg" alt="" class="QRcodeImg-box-box">
    </div>
    <!-- 申请借款注意事项 -->
    <div class="labourParticulars" v-if="fingerprintShow3">
        <h4 class="labourParticulars-title  labourParticulars-title-active">申请借款注意事项</h4>
        <p class="labourParticulars-title-content-active" id="textTitleContent">1. 在财务明细中填写借款金额，并选择借款类型：备用金、员工借款、客户借款、预付装修工程款、预付固定资产采购、预付存货采购。</p>
        <p class="labourParticulars-title-content-active" id="textTitleContent">2. 选择备用金、员工借款时，系统自动带出收款人类型为员工，客户借款自动带出收款人类型为客户，其他自动带出收款人类型为供应商。</p>
        <p class="labourParticulars-title-content-active" id="textTitleContent">3. 用户需根据借款类型填写对应的实际收款人，是员工、客户、供应商等。</p>
        <p class="labourParticulars-title-content-active" id="textTitleContent">4. 系统能自动带出申请人累计借款余额。</p>
        <p class="labourParticulars-title-content-active" id="textTitleContent">5. 在使用费控系统前产生的借款不可走费控系统进行借款报销。</p>
    </div>
</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow0: false,
            fingerprintShow1: false,
            fingerprintShow2: false,
            fingerprintShow3: false,
            fingerprintShow4: false,
        };
    },
    methods: {
        getOnPage1(){
            var name = this.$route.params.name
            if(name == 'op'){
                this.$router.push({name:"IssueManpower1"})
            }else {
                this.$router.push({name:"FinanceHome"})
            }
        },
        fn() {
            var code = this.$route.params.code;
            if (code == 11) {
                this.fingerprintShow0 = true;
            }else if (code == 14) {
                this.fingerprintShow3 = true;
            }
        },
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "111"
                }
            })
        },
    },
    mounted() {
        this.fn();
    }
};
</script>

<style>
.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 35px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    width: 30%;
    display: block;
    margin: 10px auto;
}

.QRcodeImg-box-box {
    width: 90%;
    height: 83%;
    display: block;
    margin: 10px auto;
}

.contentImg {
    width: 100%;
    display: block;
    margin-top: 15px;
}
.labourParticulars-title-content-active {
    letter-spacing:2px;
    line-height: 30px;
}
#textTitleContent {
    color: #888787;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Finance/finance1.vue